import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
export default function () {
    const toastSuccess = (message: string) => {
        toast(message, {
            autoClose: 3000,
            type: 'success',
            position: 'top-center',
            transition: 'slide',
            hideProgressBar: true,
            theme: 'colored',
            style: { padding: '10px' },
            toastStyle: { borderRadius: '6px', backgroundColor: '#48b866' }
        });
    }
    const toastError = (message: string) => {
        toast(message, {
            autoClose: 3500,
            type: 'error',
            position: 'top-center',
            transition: 'slide',
            hideProgressBar: true,
            theme: 'colored',
            style: { padding: '10px' },
            toastStyle: { borderRadius: '6px', backgroundColor: '#E63757' }
        });
    }
    return {
        toastSuccess,
        toastError
    }

}